module.exports = __webpack_public_path__ + "img/art_3_2.0206a0f4.png";